const previewMode = document.querySelector('.otk-shop-all-preview-mode');
const navigation = document.querySelector('.otk-shop-all-format-nav');

if (previewMode && navigation) {
  const links = [...navigation.querySelectorAll('a[href^="#"]')];
  const targets = links
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  const setActiveLink = (target) => {
    links.forEach((link) => {
      const active = link.getAttribute('href') === `#${target.id}`;
      link.classList.toggle('is-active', active);
      if (active) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  if (targets.length) {
    setActiveLink(targets[0]);

    const observer = new IntersectionObserver(
      (entries) => {
        const activeEntry = entries.find((entry) => entry.isIntersecting);
        if (activeEntry) setActiveLink(activeEntry.target);
      },
      { rootMargin: '-28% 0px -62% 0px', threshold: 0 },
    );

    targets.forEach((target) => observer.observe(target));
  }
}
